import React from "react";
import { Dropdown, Header } from "semantic-ui-react";

export const Obligaciones = [
  {
    area: "ingreso",
    type: "ingreso",
    typeLabel: "Ingreso",
    subAreas: [
      {
        type: "caja",
        typeLabel: "Caja",
        family: "ingreso",
        familyLabel: "Ingreso",
        //inEERR: false,
      },
      {
        type: "cheque_por_cobrar",
        typeLabel: "Cheque por Cobrar",
        family: "ingreso",
        familyLabel: "Ingreso",
        //inEERR: false,
      },
      {
        type: "boleta",
        typeLabel: "Boleta por Cobrar",
        family: "ingreso",
        familyLabel: "Ingreso",
        //inEERR: true,
      },
      {
        type: "otros_ingresos",
        typeLabel: "Otros Ingresos",
        family: "ingreso",
        familyLabel: "Ingreso",
        //inEERR: true,
      },
      {
        type: "nota_venta",
        typeLabel: "Nota de Venta",
        family: "ingreso",
        familyLabel: "Ingreso",
        //inEERR: false,
      },
      {
        type: "anticipo_cliente",
        typeLabel: "Anticipo Cliente",
        family: "ingreso",
        familyLabel: "Ingreso",
        //inEERR: false,
      },
      {
        type: "ingreso_por_transferencia",
        typeLabel: "Ingreso por Transferencia",
        family: "ingreso",
        familyLabel: "Ingreso",
        //inEERR: false,
      },
      {
        type: "ingreso_por_pos",
        typeLabel: "Ingreso por POS",
        family: "ingreso",
        familyLabel: "Ingreso",
        //inEERR: false,
      },
      // {
      //   type: "devolucion_cliente",
      //   typeLabel: "Devolución Cliente",
      //   family: "ingreso",
      //   familyLabel: "Ingreso",
      //   //inEERR: false,
      // },
    ],
  },
  {
    area: "gastos_rrhh",
    type: "gastos_rrhh",
    typeLabel: "Gastos RRHH",
    subAreas: [
      {
        type: "sueldos",
        typeLabel: "Sueldos",
        family: "gastos_rrhh",
        familyLabel: "Gastos RRHH",
        //inEERR: true,
      },
      {
        type: "leyes_sociales",
        typeLabel: "Leyes Sociales",
        family: "gastos_rrhh",
        familyLabel: "Gastos RRHH",
        //inEERR: true, //segmentarlo
      },
      {
        type: "finiquitos",
        typeLabel: "Finiquitos",
        family: "gastos_rrhh",
        familyLabel: "Gastos RRHH",
        //inEERR: true,
      },
      {
        type: "otros_descuentos",
        typeLabel: "Otros descuentos",
        family: "gastos_rrhh",
        familyLabel: "Gastos RRHH",
        //inEERR: true,
      },
    ],
  },
  {
    area: "otros_pagos_mensuales",
    type: "otros_pagos_mensuales",
    typeLabel: "Otros Pagos Mensuales",
    subAreas: [
      {
        type: "arriendo",
        typeLabel: "Arriendo",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "ggcc_&_servicios_basicos",
        typeLabel: "GGCC & Servicios Básicos",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "cheques_por_pagar",
        typeLabel: "Cheque por Pagar",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: false,
      },
      {
        type: "multa",
        typeLabel: "Multa",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "diferencia_de_pago",
        typeLabel: "Diferencia de Pago",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "diferenciadetipodecambio",
        typeLabel: "Diferencia de Tipo de Cambio",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "sobregiro_cuenta_corriente",
        typeLabel: "Sobregiro Cuenta Corriente",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "comision_bancaria",
        typeLabel: "Comisión Bancaria",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "comision_por_venta",
        typeLabel: "Comisión por Venta",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "comision_por_factoring",
        typeLabel: "Comisión por Factoring",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "orden_de_compra",
        typeLabel: "Orden de Compra",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "gastos_varios",
        typeLabel: "Gastos Varios",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "boleta_por_pagar",
        typeLabel: "Boleta por Pagar",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
    ],
  },
  {
    area: "rendiciones",
    type: "rendiciones",
    typeLabel: "Rendiciones",
    subAreas: [
      {
        type: "fondo_por_rendir",
        typeLabel: "Fondo por Rendir",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
      {
        type: "gasto_anticipado",
        typeLabel: "Gasto Anticipado",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
      {
        type: "rendición_de_gastos",
        typeLabel: "Rendición de Gastos",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
      {
        type: "anticipos",
        typeLabel: "Anticipos",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
      {
        type: "anticipodehonorarios",
        typeLabel: "Anticipo de Honorarios",
        family: "rendiciones",
        familyLabel: "Rendiciones",
      },
      {
        type: "reembolso",
        typeLabel: "Reembolso",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
      {
        type: "caja_chica",
        typeLabel: "Caja Chica",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: true,
      },
      {
        type: "reposicion_caja_chica",
        typeLabel: "Reposición Caja Chica",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
      {
        type: "regularizacion_bancaria",
        typeLabel: "Regularización Bancaria",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
      {
        type: "traspaso_entre_cuentas",
        typeLabel: "Traspaso entre Cuentas",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
      {
        type: "pago_por_un_tercero",
        typeLabel: "Pago por un Tercero",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
      {
        type: "efectivo",
        typeLabel: "Pago en Efectivo",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
    ],
  },
  {
    area: "internacional",
    type: "internacional",
    typeLabel: "Internacional",
    subAreas: [
      {
        type: "invoice",
        typeLabel: "Invoice",
        family: "internacional",
        familyLabel: "Internacional",
        //inEERR: true,
      },
      {
        type: "declaracion_de_ingreso(din)",
        typeLabel: "Declaración de Ingreso (DIN)",
        family: "internacional",
        familyLabel: "Internacional",
        //inEERR: false,
      },
    ],
  },
  {
    area: "financiamiento",
    type: "financiamiento",
    typeLabel: "Financiamiento",
    subAreas: [
      {
        type: "tarjeta_de_credito",
        typeLabel: "Tarjeta de Crédito",
        family: "financiamiento",
        familyLabel: "Financiamiento",
        //inEERR: false,
      },
      {
        type: "cuota_credito",
        typeLabel: "Cuota de Crédito",
        family: "financiamiento",
        familyLabel: "Financiamiento",
        //inEERR: false,
      },
      {
        type: "capital_de_trabajo",
        typeLabel: "Capital de Trabajo",
        family: "financiamiento",
        familyLabel: "Financiamiento",
        //inEERR: false,
      },
      {
        type: "prestamo_socio",
        typeLabel: "Préstamo Socio",
        family: "financiamiento",
        familyLabel: "Financiamiento",
        //inEERR: false,
      },
      {
        type: "prestamo_empresa_relacionada",
        typeLabel: "Préstamo empresa relacionada",
        family: "financiamiento",
        familyLabel: "Financiamiento",
        //inEERR: false,
      },
      {
        type: "factoring",
        typeLabel: "Factoring",
        family: "financiamiento",
        familyLabel: "Financiamiento",
        //inEERR: false,
      },
    ],
  },
  {
    area: "inversion",
    type: "inversion",
    typeLabel: "Inversión",
    subAreas: [
      {
        type: "fondos_mutuos",
        typeLabel: "Fondos Mútuos",
        family: "inversion",
        familyLabel: "Inversión",
        //inEERR: false,
      },
      {
        type: "deposito_a_plazo",
        typeLabel: "Deposito a Plazo",
        family: "inversion",
        familyLabel: "Inversión",
        //inEERR: false,
      },
      {
        type: "fondo_de_inversion",
        typeLabel: "Fondo de Inversión",
        family: "inversion",
        familyLabel: "Inversión",
        //inEERR: false,
      },
      {
        type: "bonos",
        typeLabel: "Bonos",
        family: "inversion",
        familyLabel: "Inversión",
        //inEERR: false,
      },
      {
        type: "criptomonedas",
        typeLabel: "Criptomonedas",
        family: "inversion",
        familyLabel: "Inversión",
        //inEERR: false,
      },
      {
        type: "otros_instrumentos_financieros",
        typeLabel: "Otros Instrumentos Financieros",
        family: "inversion",
        familyLabel: "Inversión",
        //inEERR: false,
      },
      {
        type: "intereses_ganados",
        typeLabel: "Intereses ganados",
        family: "inversion",
        familyLabel: "Inversión",
        //inEERR: true,
      },
      {
        type: "intereses_pagados",
        typeLabel: "Intereses pagados",
        family: "inversion",
        familyLabel: "Inversión",
        //inEERR: true,
      },
    ],
  },
  {
    area: "aumento_disminucion_de_capital",
    type: "aumento_disminucion_de_capital",
    typeLabel: "Aumento / Disminución de Capital",
    subAreas: [
      {
        type: "acciones",
        typeLabel: "Acciones",
        family: "aumento_disminucion_de_capital",
        familyLabel: "Aumento / Disminución de Capital",
        //inEERR: false,
      },
      {
        type: "disminucion_de_capital",
        typeLabel: "Disminución de Capital",
        family: "aumento_disminucion_de_capital",
        familyLabel: "Aumento / Disminución de Capital",
        //inEERR: false,
      },
      {
        type: "dividendo",
        typeLabel: "Dividendo",
        family: "aumento_disminucion_de_capital",
        familyLabel: "Aumento / Disminución de Capital",
        //inEERR: false,
      },
      {
        type: "retiro_de_socio",
        typeLabel: "Retiro de Socio",
        family: "aumento_disminucion_de_capital",
        familyLabel: "Aumento / Disminución de Capital",
        //inEERR: false,
      },
    ],
  },
  {
    area: "impuestos_y_obligaciones_tributarias",
    type: "impuestos_y_obligaciones_tributarias",
    typeLabel: "Impuestos y Obligaciones Tributarias",
    subAreas: [
      {
        type: "afp_e_inp",
        typeLabel: "AFP / INP",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "isapre_y_fonasa",
        typeLabel: "Isapre / Fonasa",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "mutuales_de_seguridad",
        typeLabel: "Mutuales de Seguridad",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "caja_de_compensacion",
        typeLabel: "Caja de Compensación",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "pago_provisional_mensual_ppm",
        typeLabel: "Pago Provisional Mensual (PPM)",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "retencion_boletas_honorarios",
        typeLabel: "Retención Boletas Honorarios",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "impuesto_2da_categoria",
        typeLabel: "Impuesto 2da Categoría",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "iva_debito_credito",
        typeLabel: "IVA Débito / Crédito",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "iva_postergado",
        typeLabel: "IVA Postergado",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "pago_provisional_mensual",
        typeLabel: "Pago Provisional Mensual",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: false,
      },
      {
        type: "patente",
        typeLabel: "Patente",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: true,
      },
      {
        type: "impuesto_a_la_renta",
        typeLabel: "Impuesto a la Renta",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: true,
      },
      {
        type: "contribuciones",
        typeLabel: "Contribuciones",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: true,
      },
      {
        type: "remanente_credito_fiscal",
        typeLabel: "Remanente Crédito Fiscal",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: true,
      },
      {
        type: "legales",
        typeLabel: "Gastos legales",
        family: "impuestos_y_obligaciones_tributarias",
        familyLabel: "Impuestos y Obligaciones Tributarias",
        //inEERR: true,
      },
    ],
  },
  {
    area: "otros_pagos_y_cobros",
    type: "otros_pagos_y_cobros",
    typeLabel: "Otros Pagos y Cobros",
    subAreas: [
      {
        type: "leasing",
        typeLabel: "Leasing",
        family: "otros_pagos_y_cobros",
        familyLabel: "Otros Pagos y Cobros",
        //inEERR: false,
      },
      {
        type: "seguros",
        typeLabel: "Seguros",
        family: "otros_pagos_y_cobros",
        familyLabel: "Otros Pagos y Cobros",
        //inEERR: true,
      },
      {
        type: "contrato_compra_venta",
        typeLabel: "Contrato Compra/Venta",
        family: "otros_pagos_y_cobros",
        familyLabel: "Otros Pagos y Cobros",
        //inEERR: false,
      },
      {
        type: "garantias",
        typeLabel: "Garantía",
        family: "otros_pagos_y_cobros",
        familyLabel: "Otros Pagos y Cobros",
        //inEERR: false,
      },
      {
        type: "devolucion",
        typeLabel: "Devolución",
        family: "otros_pagos_y_cobros",
        familyLabel: "otros_pagos_y_cobros",
        //inEERR: false,
      },
      {
        type: "movimientosinaclarar",
        typeLabel: "Movimiento sin Aclarar",
        family: "otros_pagos_y_cobros",
        familyLabel: "Otros Pagos y Cobros",
        //inEERR: false,
      },
    ],
  },
  {
    area: "gastos",
    type: "gastos",
    typeLabel: "Gastos",
    subAreas: [
      {
        type: "rendiciontarjetacreditonacional",
        typeLabel: "Rendición Tarjeta de Crédito Nacional",
        family: "gastos",
        familyLabel: "Gastos",
      },
      {
        type: "rendiciontarjetacreditointernacional",
        typeLabel: "Rendición Tarjeta de Crédito Internacional",
        family: "gastos",
        familyLabel: "Gastos",
      },
    ],
  },
  {
    area: "proyeccion",
    type: "proyeccion",
    typeLabel: "Proyección",
    subAreas: [
      {
        type: "proyeccion",
        typeLabel: "Proyección",
        family: "proyeccion",
        familyLabel: "Proyección",
        //inEERR: false,
      },
    ],
  },
];
export const ObligationsWithParse = [
  {
    area: "otros_pagos_mensuales",
    type: "otros_pagos_mensuales",
    typeLabel: "Otros Pagos Mensuales",
    subAreas: [
      {
        type: "diferencia_de_pago",
        typeLabel: "Diferencia de Pago",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "comision_por_factoring",
        typeLabel: "Comisión por Factoring",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "comision_por_venta",
        typeLabel: "Comisión por Venta",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
      {
        type: "comision_bancaria",
        typeLabel: "Comisión Bancaria",
        family: "otros_pagos_mensuales",
        familyLabel: "Otros Pagos Mensuales",
        //inEERR: true,
      },
    ],
  },
  {
    area: "rendiciones",
    type: "rendiciones",
    typeLabel: "Rendiciones",
    subAreas: [
      {
        type: "efectivo",
        typeLabel: "Pago en Efectivo",
        family: "rendiciones",
        familyLabel: "Rendiciones",
        //inEERR: false,
      },
    ],
  },
  {
    area: "financiamiento",
    type: "financiamiento",
    typeLabel: "Financiamiento",
    subAreas: [
      {
        type: "factoring",
        typeLabel: "Factoring",
        family: "financiamiento",
        familyLabel: "Financiamiento",
        //inEERR: false,
      },
    ],
  },
];

export const flattenedObligtionsAreas = Obligaciones.reduce((acc, area) => {
  return acc.concat(area.subAreas);
}, []);


const options = Obligaciones.reduce((acc, el) => {
  if (!acc) acc = [];
  const header = [
    {
      id: el.type,
      type: el.type,
      text: el.typeLabel,
      disabled: true,
      content: (
        <Header
          style={{ fontSize: "1em" }}
          content={el.typeLabel}
          size="small"
        />
      ),
    },
  ];
  const children = el.subAreas.map((f) => ({
    id: f.type,
    name: f.type,
    text: f.typeLabel,
    value: f.type,
    disabled: false,
    content: f.typeLabel,
  }));
  const mix = [...header, ...children];

  acc = [...acc, ...mix];
  return acc;
}, []);

export const ObligacionesDropdown = ({
  style = {},
  onChange = () => { },
  onBlur = () => { },
  className = "",
  id = "type",
  name = "type",
  placeholder = "Seleccione una Obligación...",
  multiple,
  clearable = true,
  value = "",
  upward = false,
  open,
  onOpen,
  onClose,
}) => {
  return (
    <Dropdown
      selectOnBlur={false}
      className={className}
      multiple={multiple}
      style={{ ...style }}
      placeholder={placeholder}
      id={id}
      name={name}
      value={value}
      options={options}
      onChange={onChange}
      onBlur={onBlur}
      clearable={clearable}
      selection
      search
      fluid
      upward={upward}
      noResultsMessage="No existe este elemento"
      open={open}
      onOpen={onOpen}
      onClose={onClose}
    />
  );
};
